<form #form="ngForm">
  <hw-form-row>
    <div *hw-form-col>
      <hw-form-item name="observationType" label="mdm.obs-def-02.form.type" required>
        <hw-term-codesystem-concept-select
          [(ngModel)]="definition.type"
          (ngModelChange)="clearDataTypeSettings()"
          name="observationType"
          codesystem="observation-type"
          valueType="codeName"
          required></hw-term-codesystem-concept-select>
      </hw-form-item>

      <hw-form-item
        name="calculatedValue"
        label="mdm.obs-def-02.form.calculated-value"
        *ngIf="definition.type.code === 'calculated'"
        required>
        <hw-observation-definition-range-hint
          name="range"
          [(input)]="definition.calculatedValue"
          [definition]="definition"></hw-observation-definition-range-hint>
      </hw-form-item>

      <hw-form-item name="dataType" label="mdm.obs-def-02.form.data-type">
        <hw-term-codesystem-concept-select
          [(ngModel)]="definition.dataType"
          (ngModelChange)="updateMeasurementUnit($event)"
          name="dataType"
          valueType="codeName"
          [concepts]="dataTypes | values | filter : filterAvailableDataTypes"></hw-term-codesystem-concept-select>
      </hw-form-item>

      <hw-data-options
        name="dataOptions"
        [(ngModel)]="definition.dataOptions"
        [dataType]="definition.dataType?.code"></hw-data-options>

      <nz-divider></nz-divider>
      <ng-container *ngIf="dataTypes[definition.dataType?.code]?.attributes['measurable']">
        <hw-form-item name="measurementUnitKind" label="mdm.obs-def-02.form.unit-kind">
          <hw-term-codesystem-concept-select
            [(ngModel)]="definition.unitKind"
            (ngModelChange)="definition.defaultUnit = {}"
            valueType="codeName"
            codesystem="measurement-unit-kind"
            name="measurementUnitKind"></hw-term-codesystem-concept-select>
        </hw-form-item>

        <hw-form-item name="defaultMeasurementUnit" label="mdm.obs-def-02.form.default-unit">
          <hw-select name="defaultMeasurementUnit" [(ngModel)]="definition.defaultUnit" [compareWith]="byUnitCode">
            <hw-option
              *ngFor="let u of measurementUnits | filter : filterByMeasurementUnitKind : definition.unitKind"
              [label]="(u.names | localName) + ' (' + (u.alias | localName) + ')'"
              [value]="u"></hw-option>
          </hw-select>
        </hw-form-item>
      </ng-container>

      <hw-form-item name="code" label="mdm.obs-def-02.form.view-template">
        <textarea nz-input name="viewTemplate" [(ngModel)]="definition.viewTemplate"></textarea>
      </hw-form-item>
    </div>
  </hw-form-row>
</form>
